import { type AlertDialogTitleProps, AlertDialog as BaseAlertDialog } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { Title } from '../Title/Title';
import { titleStyle } from './AlertDialog.css';

type Props = AlertDialogTitleProps;

export const AlertDialogTitle = ({ children, ...delegated }: Props) => {
  return (
    <BaseAlertDialog.Title {...delegated} className={clsxs(titleStyle, delegated.className)} render={<Title as="h2" />}>
      {children}
    </BaseAlertDialog.Title>
  );
};
